import { useState } from "react";
import styles from "./InfoSection.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaArrowAltCircleRight } from "react-icons/fa";
import RegistrierenPopup from "../popups/RegistrierenPopup";
import LoginPopup from "../popups/LoginPopup";

export default function InfoSection() {
    const [isRegisterPopupOpen, setIsRegisterPopupOpen] = useState(false);
    const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);

    const handleOpenRegisterPopup = () => {
        setIsRegisterPopupOpen(true);
        setIsLoginPopupOpen(false);
    };

    const handleCloseRegisterPopup = () => {
        setIsRegisterPopupOpen(false);
    };

    const handleOpenLoginPopup = () => {
        setIsLoginPopupOpen(true);
        setIsRegisterPopupOpen(false);
    };

    const handleCloseLoginPopup = () => {
        setIsLoginPopupOpen(false);
    };

    return (
        <div className={styles.container}>
            <div className={styles.leftSection}>
                <div>
                    <p className={styles.title}>ONLINE-<br />
                        BUCHUNG
                        </p>
                    <div className={`${commonStyles.sectionBorderBottom} ${styles.borderBottom}`} />
                </div>
                <p className={styles.description}>
                    Willkommen beim Onlinebuchungstool der Flexi.<br />
                    Nach Ihrer persönlichen Anmeldung bei den Mitarbeitenden der
                    Flexi können Sie sich hier registrieren und Betreuungszeiten buchen.
                </p>
                <div className={styles.button_container}>
                    <button className={`${commonStyles.commonButton} ${styles.registrierenButton}`} onClick={handleOpenRegisterPopup}>
                        <span>Registrieren</span>
                        <FaArrowAltCircleRight className={commonStyles.commonButtonIcon} />
                    </button>
                </div>
            </div>
            <div className={styles.rightSection}>
                <img src="https://www.studierendenwerk-siegen.de/wp-content/uploads/2022/01/jubelnde-kinder.jpg" alt="jubelnde-kinder" className={styles.image} />
            </div>

            <RegistrierenPopup
                isOpen={isRegisterPopupOpen}
                onClose={handleCloseRegisterPopup}
                togglePopup={handleOpenLoginPopup}
            />

            <LoginPopup
                isOpen={isLoginPopupOpen}
                onClose={handleCloseLoginPopup}
                togglePopup={handleOpenRegisterPopup}
            />
        </div>
    );
}
